import React from 'react';

import OngoingRecording from 'assets/images/svgs/Recording/ico_ongoing_recording.svg';
import OngoingRecordingBlack from 'assets/images/svgs/Recording/ico_ongoing_recording_black.svg';

type Props = { highlighted: boolean; size: number };

function OngoingSingleRecording({ highlighted, size }: Props) {
    return highlighted ? (
        <OngoingRecordingBlack width={size} height={size} />
    ) : (
        <OngoingRecording width={size} height={size} />
    );
}

export default OngoingSingleRecording;
